<template>
    <header :class="ui.root()">
        <div :class="ui.left()">
            <Motion
                :while-hover="SidebarToggleMotion.Hover"
                :while-press="SidebarToggleMotion.Press"
                :transition="SidebarToggleMotion.Transition"
                :class="ui.toggleMotion()">
                <UButton :class="ui.toggleButton()" :variant="ButtonVariants.IconControl" @click="toggleSidebar">
                    <span :class="ui.toggleLabel()">{{ isSidebarOpen ? 'Close sidebar' : 'Open sidebar' }}</span>
                    <div :class="ui.burger()">
                        <div :class="ui.burgerLine()" />
                        <div :class="ui.burgerLineSecond()" />
                        <div :class="ui.burgerLineThird()" />
                    </div>
                </UButton>
            </Motion>
        </div>
    </header>
</template>

<script setup lang="ts">
    import { ButtonVariants } from '@constants/button-variants';
    import { SidebarToggleMotion } from '@constants/motion';
    const { isSidebarOpen, toggleSidebar } = useSidebar();

    const ui = useComponentUi('mainContentIslandHeader', () => ({
        sidebarOpen: isSidebarOpen.value
    }));
</script>
